var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    "+_vm._s(_vm.seasons)+"\n    "),(_vm.movie.response.videos.length ==0)?_c('h2',{staticClass:"text-danger"},[_vm._v("No Videos")]):_vm._e(),(_vm.movie.response.videos.length !=0)?_c('vs-button',{on:{"click":function($event){return _vm.pushToOld()}}},[_vm._v("add To Old")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }